import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

const authUrl = process.env.REACT_APP_API_ENDPOINT_AUTH;
const jobsUrl = process.env.REACT_APP_API_ENDPOINT_JOBS;
const clientId = process.env.REACT_APP_API_CLIENT_ID;
const secret = process.env.REACT_APP_API_SECRET;

function App() {
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPositionCity, setJobPositionCity] = useState([]);
  const [selectedCityId, setSelectedCityId] = useState("");
  const [jobPositionTitle, setJobPositionTitle] = useState([]);
  const [selectedTitleId, setSelectedTitleId] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const [jobPosition, setJobPosition] = useState([]);

  // paginação vagas efetivas
  const itemsPerPage = 5;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const filteredJobs = useMemo(() => {
    return jobs.filter((job) => {
      const matchesCity =
        !selectedCityId || job.cityId === Number(selectedCityId);

      const matchesTitle =
        !selectedTitleId || job.titlePositionId === Number(selectedTitleId);

      return matchesCity && matchesTitle;
    });
  }, [jobs, selectedCityId, selectedTitleId]);

  const currentEffectiveJobs = filteredJobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs,
  );
  const pageCountEffectiveJobs = Math.ceil(filteredJobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const generateNonce = () => {
    const nonce = Math.floor(Math.random() * 1000000000);
    return nonce;
  };

  const generateTimestamp = () => {
    const timestamp = Math.floor(Date.now() / 1000).toString();
    return timestamp;
  };

  const onChangeFilterJobsCity = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedCityId($event.target.value);
  };

  const onChangeFilterJobsTitle = ($event) => {
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    setSelectedTitleId($event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);

      let retries = 0;
      let success = false;

      while (retries <= 2 && !success) {
        try {
          let token = localStorage.getItem("api_token");
          let storedNonce =
            localStorage.getItem("api_nonce") || generateNonce();
          let storedTimestamp =
            localStorage.getItem("api_timestamp") || generateTimestamp();

          if (!token) {
            const authResponse = await fetch(`${authUrl}`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Nonce": storedNonce,
                "X-Timestamp": storedTimestamp,
              },
              body: JSON.stringify({
                clientId: clientId,
                secret: secret,
              }),
            });

            if (!authResponse.ok) throw new Error("Erro na autenticação");

            const authData = await authResponse.json();
            token = authData.token;

            localStorage.setItem("api_token", token);
            localStorage.setItem("api_nonce", storedNonce);
            localStorage.setItem("api_timestamp", storedTimestamp);
          }

          const dataResponse = await fetch(`${jobsUrl}`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
              "X-Target": "garoto",
              "X-Nonce": storedNonce,
              "X-Timestamp": storedTimestamp,
            },
          });

          if (dataResponse.status === 401) {
            localStorage.clear();

            retries++;
            continue;
          }

          if (!dataResponse.ok) throw new Error("Erro ao buscar dados");

          const jobsData = await dataResponse.json();

          setJobs(jobsData.jobPositionList);
          setJobPositionCity(jobsData.cityList);
          setJobPositionTitle(jobsData.titlePositionList);

          success = true;
        } catch (error) {
          console.error("Erro no fluxo:", error);
          retries++;
        }
      }

      setShowLoader(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      <nav className="bg-[#0F1941] h-24">
        <div className="flex items-center justify-between p-4 pr-[10%] relative max-[768px]:justify-center">
          <div>
            <img
              src="./assets/icons/randstad-logo.png"
              alt="Randstad Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li className="pr-[10%]">
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full bg-[#2074D9] flex justify-center items-center">
        <div
          id="main-title"
          className="flex flex-col items-center z-10 w-full max-[1024px]:hidden"
        >
          <p className="text-white text-6xl font-graphik mr-[10%] max-[768px]:text-xl tracking-tighter">
            venha fazer parte
          </p>
          <p className="text-white text-6xl font-graphik ml-[20%] max-[768px]:text-xl tracking-tighter">
            da nossa equipe!
          </p>
          <img
            src="./assets/images/logo-garoto-white.png"
            alt="Chocolates Garoto Landing Page"
            className="w-44 ml-[0%] mt-3"
          />
        </div>
        <div className="w-full max-[1024px]:hidden">
          <img
            src="./assets/images/banner-04.png"
            alt="Chocolates Garoto Landing Page"
            className="w-full"
          />
        </div>
        <div className="w-full md:hidden">
          <img
            src="./assets/images/banner-04-responsive.png"
            alt="Chocolates Garoto Landing Page"
            className="w-full"
          />
          <p className="text-white text-7xl font-graphik flex self-start ml-4 max-[768px]:text-4xl tracking-tighter">
            venha fazer parte
          </p>
          <p className="text-white text-7xl font-graphik items-center flex justify-center ml-[15%] max-[768px]:text-4xl tracking-tighter">
            da nossa equipe!
          </p>
          <div className="flex justify-center items-center pb-8">
            <img
              src="./assets/images/logo-garoto-white.png"
              alt="Chocolates Garoto Landing Page"
              className="w-28 mt-3"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-wrap w-full bg-white py-14 pl-[7vw] pr-[9vw]">
        <h1 className="text-3xl text-blue-500 font-regular mb-6 max-[768px]:text-center max-[768px]:text-4xl">
          a parceria entre Chocolates Garoto e a Randstad
        </h1>
        <div
          id="parceria"
          className="w-full flex flex-row gap-6 max-[768px]:flex-col"
        >
          <div className="w-full flex max-[768px]:w-full">
            <p className="text-black text-lg max-[768px]:text-xl font-light">
              A Chocolates Garoto, em parceria com a Randstad, líder global em
              recrutamento e soluções de recursos humanos, presente em mais de
              39 países pelo mundo, uniu forças para garantir um processo
              seletivo que além de selecionar talentos, também apresente como é
              trabalhar com{" "}
              <span className="text-[#2074D9]">
                uma das marcas mais amadas e tradicionais do Brasil
              </span>
              , conhecida por sua qualidade, sabor e tradição na fabricação de
              chocolates há mais de 80 anos, através de contratações
              temporárias, garantindo assim, a combinação{" "}
              <span className="text-[#2074D9]">
                perfeita entre oportunidade e talento, buscando inovação e
                melhorias contínuas.
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="w-full pb-12 hidden md:flex justify-center items-center">
        <img
          src="./assets/images/logo.png"
          alt="Logo"
          className="h-44 w-44 mx-12"
        />
        <img
          src="./assets/images/logo-randstad.svg"
          alt="Randstad Logo"
          className="h-44 w-40 mx-12"
        />
      </div>

      <div
        className="flex w-full gap-6 py-14 pl-[7vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="flex flex-col pt-4 w-1/2 max-[768px]:w-full max-[768px]:pr-8">
          <h1 className="text-3xl font-regular text-blue-500 mb-8">
            sobre a Chocolates Garoto
          </h1>
          <p className="text-xl mb-8 text-[#2175D9]">
            Garoto: Tradição brasileira em chocolates há mais de 80 anos!
          </p>
          <p className="text-lg text-black mb-2 font-light">
            Uma renomada empresa brasileira especializada na fabricação de
            chocolates e confeitos. Fundada em 1929 em Vila Velha, Espírito
            Santo, a empresa conquistou reconhecimento e carinho dos
            consumidores ao longo dos anos. A Garoto é famosa por oferecer uma
            ampla variedade de produtos, como bombons, barras de chocolate, ovos
            de Páscoa, trufas e wafer. Seus chocolates são apreciados pela alta
            qualidade e variedade de sabores.
          </p>
          <p className="text-lg text-black mb-6 font-light">
            A Chocolates Garoto é reconhecida como uma das marcas mais
            tradicionais e amadas pelos brasileiros quando se trata de
            chocolates. Sua longa trajetória, qualidade dos produtos e inovação
            contínua é uma referência no mercado de chocolates no Brasil.
          </p>

          <a href="#oportunidades" className="w-[350px]">
            <button className="bg-[#2074D9] text-white w-full h-[60px] rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              clique aqui e confira nossas vagas
            </button>
          </a>
        </div>

        <div className="w-1/2.5 h-auto max-[768px]:hidden">
          <img
            src="./assets/images/banner-02.png"
            alt="Chocolates Garoto"
            className="w-full"
          />
        </div>
      </div>

      <div
        className="flex w-full gap-6 py-14 pl-[7vw] pr-[9vw] max-[768px]:flex-col !pt-0"
        id="sobre"
      >
        <div className="flex flex-col w-full max-[768px]:w-full">
          <h1 className="text-3xl font-regular text-blue-500 mb-4 max-[768px]:text-center">
            missão Chocolates Garoto
          </h1>
          <p className="text-lg text-black mb-6 font-light">
            A missão da Chocolates Garoto é encantar e agradar os consumidores,
            oferecendo produtos de alta qualidade e sabor inigualável. A empresa
            busca criar momentos especiais e de prazer através de seus
            chocolates e confeitos, proporcionando experiências sensoriais
            únicas. 
          </p>
          <p className="text-lg text-black mb-6 font-light">
            Ela visa manter uma relação próxima e de confiança com os seus
            consumidores, entendendo as suas motivações e necessidades. A
            empresa busca constantemente aprimorar seus produtos e lançar
            novidades, acompanhando as tendências do mercado e surpreendendo
            seus clientes.
          </p>
        </div>
      </div>

      <div id="proposito" className="w-full flex flex-row gap-6 px-[7vw]">
        <div className="w-[40%] max-[768px]:hidden">
          <img
            src="./assets/images/banner-03.png"
            alt="Chocolates Garoto"
            className="w-full h-[90%]"
          />
        </div>

        <div className="w-[60%] flex flex-col max-[768px]:w-full">
          <h1 className="text-3xl font-regular text-blue-500 mb-4 max-[768px]:text-center">
            alguns diferenciais
          </h1>
          <p className="text-lg text-black mb-6 font-light">
            Alguns benefícios que você terá trabalhando na Chocolates Garoto
            através da Randstad:
          </p>
          <div className="space-y-2 mb-6">
            <p className="text-lg text-black font-light">
              • Salário R$1598,00{" "}
            </p>
            <p className="text-lg text-black font-light">• Vale Transporte </p>
            <p className="text-lg text-black font-light">
              • Refeitório no local
            </p>
            <p className="text-lg text-black font-light">• Seguro de Vida</p>
            <p className="text-lg text-black font-light">
              • Assistência Médica
            </p>
            <p className="text-lg text-black font-light">
              • Descontos nos Produtos da Loja Garoto e Grêmio Nestlé Vila
              Velha/ES{" "}
            </p>
            <p className="text-lg text-black font-light">
              • Programa de capacitação e treinamentos internos
            </p>
            <p className="text-lg text-black font-light">
              • Estacionamento e Bicicletário privativo
            </p>
            <p className="text-lg text-black font-light">
              • Centro Esportivo Garoto
            </p>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col justify-center px-[7vw] max-[768px]:mt-14">
        <h1 className="text-3xl font-regular text-blue-500 mb-4 font-graphik max-[768px]:text-center ">
          toda história tem um bom começo!
        </h1>
        <p className="text-lg text-black mb-4 font-light">
          Foi assim que a Randstad surgiu: de uma grande ideia, através de uma
          bicicleta.
        </p>
        <p className="text-lg text-black mb-4 font-light">
          Foi de bike que nosso fundador, lá na Holanda em 1960, levou a
          primeira candidata à sua entrevista de emprego. Hoje, a Randstad é
          líder global em recrutamento e soluções completas de recursos humanos.
        </p>
        <p className="text-lg text-black font-light">
          Nosso propósito é apoiar o maior número possível de pessoas a alcançar
          seu verdadeiro potencial ao longo de suas vidas profissionais. E temos
          a ambição de ser a empresa de talentos mais equitativa e especializada
          do mundo.
        </p>
      </div>
      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-3xl font-graphik text-blue-500 mb-4 max-[768px]:text-2xl">
          quer uma oportunidade? Então faça sua inscrição!
        </h1>
        <div className="flex max-lg:flex-col justify-between max-lg:gap-4 w-full">
          <select
            onChange={onChangeFilterJobsCity}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas as cidades</option>
            {jobPositionCity.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name} {jobId.stateCode ? `- ${jobId.stateCode}` : ""}
              </option>
            ))}
          </select>
          <select
            onChange={onChangeFilterJobsTitle}
            defaultValue=""
            className="max-lg:w-full filter-btn w-[350px] mb-4 p-2 cursor-pointer"
          >
            <option value="">Todas os cargos</option>
            {jobPositionTitle.map((jobId, i) => (
              <option value={jobId.id} key={i}>
                {jobId.name}
              </option>
            ))}
          </select>
        </div>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 font-light">{job.name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.shortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="bg-[#f7f5f0] px-[7vw] py-12">
        <div>
          <p className="text-black text-2xl mb-8 ">
            Buscando dicas para a sua carreira? Confira nosso blog
          </p>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            className="border border-blue-500 text-blue-500 py-3 px-6 rounded-sm hover:bg-blue-500 hover:text-white transition max-[768px]:hidden"
            rel="noreferrer"
          >
            acesse nosso blog
          </a>
          <a
            href="https://www.randstad.com.br/guia-carreira/"
            target="_blank"
            rel="noreferrer"
            className="md:hidden"
          >
            <button className="text-blue-500 border-1 border-[#2074D9] w-full h-[60px] hover:text-white rounded-sm hover:bg-blue-600 max-[768px]:w-full">
              acesse nosso blog
            </button>
          </a>
        </div>
      </div>

      <footer className="bg-[#2074D9] text-white pt-4">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="md:text-left mb-4 md:mb-0">
            <p>
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p className="mb-4">
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
            <p>
              A Randstad trata dados pessoais de acordo com a LGPD (Lei
              13.709/18). Leia nosso Aviso de Privacidade.
            </p>
          </div>

          <div className="flex space-x-4 pb-8">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin-logo.png" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube-logo.png" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook-logo.png" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img
                src="./assets/icons/instagram-logo.png"
                alt="Instagram Logo"
              />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
